<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading0">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse0" aria-expanded="false" aria-controls="collapse0">
                Datum indiensttreding & uitdiensttreding
            </button>
        </h2>
        <div id="collapse0" class="accordion-collapse collapse" aria-labelledby="heading0"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Vul de aanvangsdatum van het dienstverband in.
                <div>
                    <p>Start het dienstverband bijvoorbeeld op zaterdag 1 november 2025 en is de feitelijke eerste
                        werkdag op maandag 3 november 2025, dan voer je 01-11-2025 als datum indiensttreding in.</p>
                </div>

                <p>Voor datum uitdiensttreding geldt hetzelfde. Loopt het dienstverband af op zaterdag 31 januari 2026
                    en de feitelijke laatste werkdag op vrijdag 30 januari 2026, dan voer je 31-01-2026 als datum
                    uitdiensttreding in.</p>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse1" aria-expanded="false" aria-controls="collapse1">
                Nummer inkomstenverhouding
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <div>
                    <p>Je geeft elke inkomstenverhouding een nummer en je vermeldt dit in de loonstaat. In de aangifte
                        loonheffingen moet je dit nummer invullen. Veel salarissoftwarepakketten doen dit automatisch
                        voor je.</p>
                </div>

                <p>Voor het nummer inkomstenverhouding houd je rekening met het volgende:</p>

                <ul>
                    <li>Als je voor de 1e keer een nummer inkomstenverhouding toekent aan een werknemer, kun je het
                        beste beginnen bij 0001. Als de inkomstenverhouding eindigt en er weer een nieuwe
                        inkomstenverhouding begint met dezelfde werknemer, nummert je door. Zo loop je weinig risico dat
                        je nummers hergebruikt als je overstapt op een ander salaris- of aangiftepakket.
                    </li>

                    <li>Heb je voor een inkomstenverhouding eenmaal een bepaald nummer gekozen? Gebruik dat nummer dan
                        in alle volgende aangiften voor die inkomstenverhouding. Dit geldt ook als je overstapt op een
                        ander salaris- of aangiftepakket. Vraag je softwareleverancier hoe je de nummers kunt vinden in
                        de oude software en daaruit kunt kopiëren.
                    </li>

                    <li>Neem je een ex-werknemer aan? Je mag een gebruikt nummer inkomstenverhouding niet hergebruiken
                        bij hetzelfde loonheffingennummer. Dit mag pas na 7 jaar na het jaar waarin de dienstbetrekking
                        is beëindigd.
                    </li>

                    <li>Je gebruikt voor iedere inkomstenverhouding in je aangifte of correctie een unieke combinatie
                        van bsn en nummer inkomstenverhouding. Deze combinatie mag maar 1 keer voorkomen in je aangifte
                        of correctie. Komt dezelfde combinatie toch vaker voor? Dan krijgt de verzender een foutmelding
                        of een brief met het verzoek om de fout te verbeteren (zie paragraaf 13.3, fase 3).
                    </li>
                </ul>
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Reden uitdiensttreding
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                De reden van uitdiensttreding moet worden opgegeven wanneer het dienstverband wordt beeïndigd. Daarbij
                heb je de volgende mogelijkheden:<br/>
                <ul>
                    <li>Opzegging vanwege langdurige arbeidsongeschiktheid</li>
                    <li>Ontslag wegens bedrijfseconomische redenen</li>
                    <li>Opzegging door werknemer</li>
                    <li>Ontbinding door rechter</li>
                    <li>Ontslag wegens dringende redenen</li>
                    <li>Looptijd overeenkomst verstreken</li>
                    <li>Overige redenen</li>
                </ul>

                De reden van einde arbeidsverhouding gaat mee in de loonaangifte naar de Belastingdienst. De
                Belastingdienst gebruikt deze informatie voor controles en statistieken. Het heeft invloed op WW-rechten
                en andere uitkeringen (via UWV). Dit is onderdeel van de digitale koppeling tussen werkgevers,
                Belastingdienst en UWV voor een naadloze uitwisseling van arbeidsmarktgegevens.

                <p>Welke reden in welke situatie moet worden gebruikt staat beschreven in het <a
                        href="https://www.belastingdienst.nl/wps/wcm/connect/bldcontentnl/themaoverstijgend/brochures_en_publicaties/handboek-loonheffingen"
                        target="_blank"><strong>Handboek loonheffingen</strong></a>, hoofdstuk 29, onderwerp 'Code reden
                    einde arbeidsverhouding'</p>
            </div>
        </div>
    </div>
</div>

